import * as React from 'react'
import { FunctionComponent } from 'react'
import { Route, Switch } from 'react-router'
import AddFile from './File/AddFile'
import FileOverview from './File/FileOverview'
import EditFile from './File/EditFile'
import ViewFile from './File/ViewFile'

const Files: FunctionComponent = () => (
    <Switch>
        <Route exact path="/file" component={FileOverview} />
        <Route path="/file/add" component={AddFile} />
        <Route path="/file/:id/edit" component={EditFile} />
        <Route
            // We cannot change the file ID param to :id, because it can encapsulate any route that already uses
            // the :id param for its own entity.
            path="/file/:fileId"
            component={ViewFile}
        />
    </Switch>
)

export default Files
